import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Header.module.css';

interface HeaderProps {
    onSoundToggle: () => void;
    isSoundMuted: boolean;
}

const Header = ({ onSoundToggle, isSoundMuted }: HeaderProps) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.hash && location.pathname === '/') {
            const sectionId = location.hash.replace('#', '');
            // Small timeout to ensure DOM is ready if navigating from another page
            setTimeout(() => {
                const element = document.getElementById(sectionId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    }, [location]);

    const scrollToSection = (sectionId: string, e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (location.pathname !== '/') {
            navigate(`/#${sectionId}`);
        } else {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState(null, '', `#${sectionId}`);
            }
        }
    };

    return (
        <header className={styles.header}>
            <div className={`container ${styles.headerContainer}`}>
                <div className={styles.logo}>
                    <div className={styles.logoIcon}></div>
                    <span className={styles.logoText}>Racine Technique</span>
                </div>

                <nav className={styles.nav}>
                    <a href="#accueil" onClick={(e) => scrollToSection('accueil', e)}>Accueil</a>
                    <a href="#services" onClick={(e) => scrollToSection('services', e)}>Services</a>
                    <a href="#portfolio" onClick={(e) => scrollToSection('portfolio', e)}>Réalisations</a>
                    <a href="#about" onClick={(e) => scrollToSection('about', e)}>À propos</a>
                    <a href="#contact" onClick={(e) => scrollToSection('contact', e)}>Contact</a>

                    <button
                        onClick={onSoundToggle}
                        className={styles.soundToggle}
                        aria-label={isSoundMuted ? "Activer le son" : "Couper le son"}
                        title={isSoundMuted ? "Activer le son" : "Couper le son"}
                    >
                        {isSoundMuted ? (
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M11 5L6 9H2v6h4l5 4V5z" />
                                <line x1="23" y1="9" x2="17" y2="15" />
                                <line x1="17" y1="9" x2="23" y2="15" />
                            </svg>
                        ) : (
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M11 5L6 9H2v6h4l5 4V5z" />
                                <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
                            </svg>
                        )}
                    </button>
                </nav>
            </div>
        </header>
    );
};

export default Header;
